import React from "react";
import { QButton, QPageLoader, QSpacer, QStack } from "@qualio/ui-components";
import { useTranslation } from "react-i18next";
import { useTraceability } from "../../hooks/designElement/useTraceability";
import { useDownloadTraceability } from "../../hooks/designElement/useDownloadTraceability";
import { TraceabilityMatrix } from "../../components/TraceabilityMatrix/TraceabilityMatrix";

export const Traceability: React.FC = () => {
  const { t } = useTranslation();
  const { isLoading, data: traceabilityMatrix } = useTraceability();
  const { onDownloadFile } = useDownloadTraceability();

  if (isLoading || !traceabilityMatrix) {
    return <QPageLoader />;
  }

  return (
    <TraceabilityMatrix matrix={traceabilityMatrix}>
      <QStack direction="row">
        <QSpacer />
        <QButton
          variant="outline"
          onClick={onDownloadFile}
          data-cy="download-matrix"
        >
          {t("traceability.actions.downloadMatrix")}
        </QButton>
      </QStack>
    </TraceabilityMatrix>
  );
};
